import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import Landing from '../pages/Landing';

const AuthGuard = () => {
  const authUser = JSON.parse(localStorage.getItem('auth'));

  if (authUser?.access_token) {
    return <Landing />;
  } else {
    window.location = '/signin';
  }
};

export default AuthGuard;
